<template>
	<div class="container-fluid">
        <div class="row mt-2">
            <div class="Titulo">Herramientas</div>
        </div>
        <div class="row mt-4">
            <div class="col- col-md-12">
                <span class="etiqueta" style="font-size: medium;">Presiona el boton para descargar catálogo de artículos:</span>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col col-md-12">
                <!-- <span class="etiqueta" style="font-size: medium;">Descargar catálogo de artículos</span> -->
                <!-- <b-button variant="primary" style="font-size: medium;"><i class="mr-2 fas fa-file-excel"></i>Descargar catálogo de artículos</b-button> -->
                <b-button class="ml-2" variant="primary" style="font-size: medium;" @click="descargarCatalogoArticulos()"><i class="mr-2 fas fa-file-excel"></i>Descargar catálogo</b-button>
            </div>
        </div>
        
        <div class="row mt-4">
            <div class="col col-md-12">
                <span class="etiqueta" style="font-size: medium;">Selecciona un rango de fecha y presiona el boton para descargar facturas:</span>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col col-md-3">
                <span class="ml-2 d-flex align-items-center">
					<span class="etiqueta" style="font-size: medium;">Desde:</span>
					<datepicker
						:format="format"
						:language="languages['es']"
						input-class="form-control form-control-sm font-16 bg-white"
						placeholder="Select Date"
						v-model="fechaInicio"
						wrapper-class="borderAzul m-2"
					/>
				</span>
            </div>
            <div class="col col-md-3">
                <span class="d-flex align-items-center">
					<span class="etiqueta" style="font-size: medium;">Hasta:</span>
					<datepicker
						:format="format"
						:language="languages['es']"
						input-class="form-control form-control-sm font-16 bg-white"
						placeholder="Select Date"
						v-model="fechaFin"
						wrapper-class="borderAzul m-2"
					/>
				</span>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col col-md-12">
                <b-button class="ml-2" variant="primary" style="font-size: medium;" @click="descargarZipFacturas()"><i class="mr-2 fas fa-file-excel"></i>Descargar facturas</b-button>
            </div>
        </div>
	</div>
</template>
<script>

import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
import * as lang from "vuejs-datepicker/src/locale"
import axios from 'axios'
// import Swal from "sweetalert2"
import moment from "moment"

export default {
    data() {
        return {
            languages: lang,
            format: "dd/MMM/yyyy",
            fechaInicio: new Date(),
            fechaFin: new Date(),
            minDate: new Date(),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0) // Fecha máxima permitida (último día del mes actual)
        }
    },
    components: {
			Datepicker,
		},
    methods:{
        validarFechas(){
            var Retorna = false
            const inicio = moment(this.fechaInicio);
            const final = moment(this.fechaFin);
            this.rangoDias = final.diff(inicio, 'days');
            

            if(this.fechaInicio > this.fechaFin){
                this.$swal.fire({
                    text: "La fecha inicio no puede ser posterior a la fecha fin",
                    icon: "warning"
                })
            } else if (this.rangoDias > 90){
                this.$swal.fire({
                    text: "El rango de fecha no puede ser mayor a 90 días",
                    icon: "warning"
                })
            }
            else {
                Retorna = true
            }

            return Retorna
        },
        async descargarCatalogoArticulos(){
            
            this.$loading(true)
            await axios.post("https://www.difarmer.com/servicio/farmasoluciones/catalogo-articulos", 
            //await axios.post("http://localhost:60110/farmasoluciones/catalogo-articulos",
                {

                }, 
                {
                    responseType: "blob"
                }
            )
            .then(function (response) {
                var blob = new Blob([response.data]);
                var url = window.URL.createObjectURL(blob);
                var link = document.createElement("a");
                link.href = url;
                link.download = "catalogoarticulos.xlsx";
                link.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(function (e) {
                this.$loading(false)
				console.log(e)
            });

            this.$loading(false)
        },

        async descargarZipFacturas(){

            if(this.validarFechas()){
                this.$loading(true)
                
                await axios.post("https://www.difarmer.com/servicio/farmasoluciones/consulta-facturas", 
                //await axios.post("http://localhost:60110/farmasoluciones/consulta-facturas", 
                    {   
                        FechaInicio: this.fechaInicio,
                        FechaFinal: this.fechaFin
                    }, 
                    {
                        responseType: "blob" 
                    }
                )
                .then(function (response) {
                    var blob = new Blob([response.data]);
                    var url = window.URL.createObjectURL(blob);
                    var link = document.createElement("a");
                    link.href = url;
                    link.download = "facturas.xlsx";
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(function (e) {
                    this.$loading(false)
						console.log(e)
                });

                this.$loading(false)
            }
        }
    },
}
</script>
